<template>
    <div id='Reporting' class='row'>
        <Report
            :initialReportState='report'
        >
            <template v-slot:buttons>
                <button class='btn btn-success' @ship-checked='shipChecked' action='ship-checked'>Ship Checked!</button>
            </template>
        </Report>
    </div>
</template>

<script>
    import Report from '../../core/report/Report.vue'
    export default{
            name: 'Reporting',
            components: {
                Report
            },
            computed: {
                report() {
                    var report = this.$store.getters['Reporting/latestReport'];
                    return report ? report : this.$store.getters['Reporting/defaultReport'];
                }
            },
            methods: {
                shipChecked(payload){
                    console.log('box shipped!')
                }
            }
        }
</script>
